const TIER_NAMES = {
  GUEST: 'guest',
  DEFAULT: 'NON-LOYALIST',
  ONE_CLICK_LOYALIST_ENROLL: 'ONE_CLICK_LOYALIST_ENROLL',
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
};

const TIER_ICONS = {
  [TIER_NAMES.BRONZE]: 'star-rewards-bronze-large',
  [TIER_NAMES.SILVER]: 'star-rewards-silver-large',
  [TIER_NAMES.GOLD]: 'star-rewards-gold-large',
  [TIER_NAMES.PLATINUM]: 'star-rewards-platinum-large',
};

const TIER_HRESHOLD = {
  SILVER: 0,
  GOLD: 500,
  PLATINUM: 1200,
};

const LOYALTY_STATES = {
  GUEST: 'guest',
  NON_LOYALIST: 'nonLoyalist',
  ONE_CLICK_LOYALIST_ENROLL: 'nonLoyalistWithOneClickEnroll',
  HAVE_STAR_MONEY: 'HaveStarMoney',
  NO_STAR_MONEY_NO_POINTS: 'NoStarMoneyNoPoints',
  NO_STAR_MONEY: 'NoStarMoney',
  UUNLOCK: 'Unlock',
};

export { TIER_NAMES, TIER_ICONS, TIER_HRESHOLD, LOYALTY_STATES };
